import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardBody, CardHeader, Table } from 'reactstrap'
import withLoader from 'hocs/with-loader'
import CardLoader from 'components/organisms/card-loader'

const propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  contents : PropTypes.array,
  children : PropTypes.any
}

/**
 * Show card information about Seller Inventory Batch
 * @param {object} title Seller Inventory Batch
 * @param {object} contents Seller Inventory Batch
 */
const InformationCard = ({
  title,
  contents,
  children
}) => (
  <Card>
    <CardHeader>
      { title }
    </CardHeader>
    <CardBody>
      <Table hover responsive className='mb-0'>
        <tbody>
          {
            contents.map((content, index) => (
              <tr key={ index }>
                <th scope='row'>{ content.label }</th>
                <td>{ content?.value ?? '-' }</td>
              </tr>
            ))
          }
        </tbody>
      </Table>
      { children }
    </CardBody>
  </Card>
)

InformationCard.propTypes = propTypes

export default withLoader(InformationCard, CardLoader)
